import { ReactElement, useId, useState } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

type ConfirmDialogProps = {
  isOpen: boolean
  title: string
  message: string
  confirmLabel?: string
  onConfirm: () => void | Promise<unknown>
  onClose: () => void
}

export default function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  onConfirm,
  onClose,
}: ConfirmDialogProps): ReactElement {
  let id = useId()
  let titleId = `${id}-title`
  let descId = `${id}-desc`
  let [isLoading, setIsLoading] = useState(false)

  let handleConfirm = () => {
    setIsLoading(true)
    Promise.resolve(onConfirm()).finally(() => setIsLoading(false))
  }

  return (
    <Dialog
      open={isOpen}
      onClose={isLoading ? undefined : onClose}
      fullWidth
      aria-labelledby={titleId}
      aria-describedby={descId}
      maxWidth="xs"
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={descId}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={handleConfirm}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={14} color="inherit" /> : null
          }
        >
          {isLoading ? 'Removing...' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
